import type * as React from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';

export function NotFound(): React.JSX.Element {
  return (
    <section className="space-y-4">
      <h1 className="text-display">Not Found</h1>
      <p className="text-body text-muted-foreground">The page you requested does not exist.</p>
      <Button asChild variant="outline">
        <Link to="/">Back to home</Link>
      </Button>
    </section>
  );
}
